import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  useDisclosure,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ImBin } from "react-icons/im";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Addfields from "../pages/Admin/Addfields";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

import { toast } from "react-toastify";
import {
  getBodyStyle,
  getCancelReason,
  getDisputeTitle,
  getFuelType,
  getSuppliertype,
  getTransmission,
  getWarranty,
} from ".././store/slices/adminSlice";
import {
  getAllPartType,
  getAllSalesRep,
  getMake,
  getMode,
} from ".././store/slices/customerSlice";
import AddModal from "./AddModal";

import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";
import { removeAuth } from "../store/slices/authSlice";
const Administration = () => {
  const [img, setImg] = useState("");
  const { makes, model, part_type, reps } = useSelector(
    (state) => state.customer
  );
  const {
    body_style,
    transmission,
    fuel_type,
    warranty,
    disputeTitle,
    suppliertype,
    cancelReason,
  } = useSelector((state) => state.admin);

  const [statusFilter, setStatusFilter] = useState("CUSTOMER");
  const { status } = useSelector((state) => state.supplier);
  const [fuel, setFuel] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: addAssignee,
    onOpen: sumAssignee,
    onClose: closeAssignee,
  } = useDisclosure();

  const navigate = useNavigate();
  let token = localStorage.getItem("accessToken");
  const [data, setData] = useState([]);
  const [property, setProperty] = useState("");
  const [sortDescriptor, setSortDescriptor] = useState({
    column: "first_name",
    direction: "ascending",
  });
  const [fieldID, setFieldID] = useState();
  const [deleteField, setDeleteField] = useState();
  const [deleteName, setDeleteName] = useState("");
  const [query, setQuery] = useState(" ");
  const [unit, setUnit] = useState("");
  const [selectedModel, setSelectedModel] = useState(null);
  const [selectedPartType, setSelectedPartType] = useState(null);
  const [selectedBodyStyle, setSelectedBodyStyle] = useState(null);
  const [selectedFuelType, setSelectedFuelType] = useState(null);
  const [selectedTransmission, setSelectedTransmission] = useState(null);
  const [selectedWarranty, setSelectedWarranty] = useState(null);
  const [selectedSupplierType, setSelectedSupplierType] = useState(null);
  const [selectedDisputeTitle, setSelectedDisputeTitle] = useState(null);
  const [selectedCancelReason, setSelectedCancelReason] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const dispatch = useDispatch();
  const {
    control,
    formState: { errors },
  } = useForm();
  const [firstName, setFirstName] = useState("");
  const [fieldName, setFieldName] = useState([]);
  const [selectedKeys, setSelectedKeys] = React.useState(new Set(["Select"]));

  // const selectedValue = React.useMemo(
  //   () => Array.from(selectedKeys).join(", ").replaceAll("_", " "),
  //   [selectedKeys]
  // );

  const getModelByMakeId = (id) => {
    setFieldID(id);
    dispatch(refreshIfNeeded()).then(() => dispatch(getMode(id)));
  };

  const addfield = async (val) => {
    // refresh token just before opening add modal (prevents expire when Addfields fires API)
    await dispatch(refreshIfNeeded());
    setProperty(val);
    setIsClicked(true);
    sumAssignee();
  };

  const getDeleteId = (val, id, name, unit) => {
    setDeleteName(val);
    setDeleteField(id);
    setQuery(name);
    setUnit(unit);
    onOpen();
  };
  const [selectedMake, setSelectedMake] = useState(null);

  const handleSelect = (make) => {
    setSelectedMake(make);
    setSelectedModel(null);
    // setSelectedModel([]);
    getModelByMakeId(make.id);
  };

  //     let token = localStorage.getItem("accessToken");
  //     if (!token) {
  //       console.error("Token not found");
  //       return;
  //     }

  //     let headers = {
  //       Authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     };

  //     const response = await fetch(
  //       `${process.env.REACT_APP_SERVER_URL}/admin/getquotes/543`, // Fixed spelling mistake
  //       {
  //         method: "GET",
  //         headers: headers,
  //       }
  //     );

  //     if (!response.ok) {
  //       console.error("Error fetching data:", response.status, response.statusText);
  //       throw new Error("Failed to fetch data");
  //     }

  //     const data = await response.json();
  //     console.log("All Quotes:", data);
  //   } catch (error) {
  //     console.error("Error:", error.message);
  //   }
  // };

  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    const token = localStorage.getItem("accessToken");
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const deleteItem = async () => {
    try {
      const headers = await ensureAuth();
      await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/admin/delete${deleteName}/${deleteField}`,
        headers
      );

      // 2️⃣  Latest data lao
      switch (deleteName) {
        case "model":
          dispatch(getMode(fieldID));
          break;
        case "bodystyle":
          dispatch(getBodyStyle());
          break;
        case "transmission":
          dispatch(getTransmission());
          break;
        case "fueltype":
          dispatch(getFuelType());
          break;
        case "cancelreason":
          dispatch(getCancelReason());
          break;
        case "disputetitle":
          dispatch(getDisputeTitle());
          break;
        case "suppliertype":
          dispatch(getSuppliertype());
          break;
        case "warranty":
          dispatch(getWarranty());
          break;
        case "part":
          dispatch(getAllPartType());
          break;
        default:
          break;
      }
      dispatch(getMake()); // Make list hamesha refresh

      // 3️⃣  UI feedback
      toast.success("Deleted successfully ⭐");
      onClose();
    } catch (err) {
      const code = err?.response?.status;
      if (code === 401) {
        toast.error("Session expired. Please log in again.");
        localStorage.clear();
        dispatch(removeAuth());
        navigate("/login");
        return;
      }
      toast.error("Delete failed");
      console.error(err);
    }
  };

  useEffect(() => {
    (async () => {
      await dispatch(refreshIfNeeded());
      dispatch(getMake());
      dispatch(getMode());
      dispatch(getAllPartType());
      dispatch(getAllSalesRep());
      dispatch(getBodyStyle());
      dispatch(getTransmission());
      dispatch(getFuelType());
      dispatch(getWarranty());
      dispatch(getDisputeTitle());
      dispatch(getSuppliertype());
      dispatch(getCancelReason());
    })();
  }, [dispatch]);
  useEffect(() => {
    if (
      selectedPartType &&
      !part_type.some((i) => i.id === selectedPartType.id)
    )
      setSelectedPartType(null);

    if (
      selectedBodyStyle &&
      !body_style.some((i) => i.id === selectedBodyStyle.id)
    )
      setSelectedBodyStyle(null);

    if (
      selectedFuelType &&
      !fuel_type.some((i) => i.id === selectedFuelType.id)
    )
      setSelectedFuelType(null);

    if (
      selectedTransmission &&
      !transmission.some((i) => i.id === selectedTransmission.id)
    )
      setSelectedTransmission(null);

    if (selectedWarranty && !warranty.some((i) => i.id === selectedWarranty.id))
      setSelectedWarranty(null);

    if (
      selectedSupplierType &&
      !suppliertype.some((i) => i.id === selectedSupplierType.id)
    )
      setSelectedSupplierType(null);

    if (
      selectedDisputeTitle &&
      !disputeTitle.some((i) => i.id === selectedDisputeTitle.id)
    )
      setSelectedDisputeTitle(null);

    if (
      selectedCancelReason &&
      !cancelReason.some((i) => i.id === selectedCancelReason.id)
    )
      setSelectedCancelReason(null);
  }, [
    part_type,
    body_style,
    fuel_type,
    transmission,
    warranty,
    suppliertype,
    disputeTitle,
    cancelReason,
  ]);

  return (
    <div className="px-4 ">
      <div className="mb-4 border-b">
        <h1 className="text-base sm:text-xl font-semibold mb-4 ">
          Admin Management Portal
        </h1>
      </div>
      <div>
        <div className="mb-2 mt-4 md:mb-0 block md:grid md:grid-cols-3 items-center gap-4">
          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Make</p>
            <Dropdown>
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="w-full text-left justify-start"
                >
                  {selectedMake ? selectedMake.name : "Select Make"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Makes List"
                className="max-h-60 overflow-y-auto"
              >
                {makes.map((make) => (
                  <DropdownItem
                    key={make.id}
                    onClick={() => handleSelect(make)}
                  >
                    {make.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("vhiclemake")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Model</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button variant="bordered" className=" w-full justify-start">
                  {selectedModel ? selectedModel.name : "Select Model"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Single selection example"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                selectedKeys={selectedKeys}
                onSelectionChange={setSelectedKeys}
                // className="h-1/4 overflow-y-scroll"
                className="max-h-60 overflow-y-auto"
              >
                {model.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.name}
                        value={item.id}
                        onClick={() => setSelectedModel(item)}
                      >
                        <div className="flex justify-between">
                          {item.name}
                          <ImBin
                            style={{
                              fontSize: "1rem",
                              marginLeft: "140px",
                              color: "gray",
                            }}
                            onClick={() =>
                              getDeleteId("model", item.id, item.name)
                            }
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {model.length === 0 && (
                  <DropdownItem key={" "} value={" "}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("vhiclemodel")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Part Type</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedPartType
                    ? selectedPartType.name
                    : "Select Part Type"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Part Types"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="w-full text-left h-[200px] overflow-y-scroll"
              >
                {part_type.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.name}
                        value={item.id}
                        onClick={() => setSelectedPartType(item)}
                      >
                        <div className="flex justify-between w-full">
                          <span>{item.name}</span>
                          <ImBin
                            style={{ fontSize: "1rem", color: "gray" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("part", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {part_type.length === 0 && (
                  <DropdownItem key={" "} value={" "}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("parts")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Body Style</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedBodyStyle
                    ? selectedBodyStyle.name
                    : "Select Body Style"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Body Style List"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {body_style.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.name}
                        value={item.id}
                        onClick={() => setSelectedBodyStyle(item)}
                      >
                        <div className="flex justify-between w-full">
                          <span>{item.name}</span>
                          <ImBin
                            style={{ fontSize: "1rem", color: "gray" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("bodystyle", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {body_style.length === 0 && (
                  <DropdownItem key={" "} value={" "}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("bodystyle")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Fuel Type</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedFuelType
                    ? selectedFuelType.name
                    : "Select Fuel Type"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Fuel Type List"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {fuel_type?.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.name}
                        value={item.id}
                        onClick={() => setSelectedFuelType(item)}
                      >
                        <div className="flex justify-between w-full">
                          <span>{item.name}</span>
                          <ImBin
                            style={{ fontSize: "1rem", color: "gray" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("fueltype", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {fuel_type.length === 0 && (
                  <DropdownItem key={" "} value={" "}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("fueltype")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Transmission</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedTransmission
                    ? selectedTransmission.name
                    : "Select Transmission"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Transmission selection"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {transmission?.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.id}
                        value={item.id}
                        onClick={() => setSelectedTransmission(item)}
                      >
                        <div className="flex justify-between">
                          {item.name}
                          <ImBin
                            style={{
                              fontSize: "1rem",
                              color: "gray",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("transmission", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {transmission.length === 0 && (
                  <DropdownItem key={" "} value={" "}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("transmission")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Warranty</p>
            <Dropdown className="w-full">
              <DropdownTrigger className="float-left text-left">
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedWarranty
                    ? `${selectedWarranty.duration} ${selectedWarranty.unit}`
                    : "Select Warranty"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Warranty selection"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {warranty.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.id}
                        value={item.id}
                        onClick={() => setSelectedWarranty(item)}
                        className="w-full"
                      >
                        <div className="flex justify-between">
                          {item.duration} {item.unit}
                          <ImBin
                            style={{
                              fontSize: "1rem",
                              color: "gray",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId(
                                "warranty",
                                item.id,
                                item.duration,
                                item.unit
                              );
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {warranty.length === 0 && (
                  <DropdownItem key="none" value="none">
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("warranty")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>
          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Supplier Type</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedSupplierType
                    ? selectedSupplierType.name
                    : "Select Supplier Type"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Supplier Type selection"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {suppliertype.map(
                  (item) =>
                    item?.id !== 0 && (
                      <DropdownItem
                        key={item.id}
                        value={item.id}
                        onClick={() => setSelectedSupplierType(item)}
                      >
                        <div className="flex justify-between w-full">
                          {item.name}
                          <ImBin
                            style={{
                              fontSize: "1rem",
                              color: "gray",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("suppliertype", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {suppliertype.length === 0 && (
                  <DropdownItem key={"none"} value={"none"}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("suppliertype")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>

          <div className="mb-2 md:mb-0">
            <p className="text-sm font-medium mb-2">Dispute Reasons</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedDisputeTitle
                    ? selectedDisputeTitle.name
                    : "Select Dispute Reason"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Single selection example"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="w-full text-left h-1/4 overflow-y-scroll"
              >
                {disputeTitle.map(
                  (item) =>
                    item?.id !== 0 &&
                    item?.id !== -1 && (
                      <DropdownItem
                        key={item.id}
                        value={item.id}
                        onClick={() => setSelectedDisputeTitle(item)}
                      >
                        <div className="flex justify-between w-full">
                          {item.name}
                          <ImBin
                            style={{
                              fontSize: "1rem",
                              color: "gray",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              getDeleteId("disputetitle", item.id, item.name);
                            }}
                          />
                        </div>
                      </DropdownItem>
                    )
                )}
                {disputeTitle.length === 0 && (
                  <DropdownItem key={"none"} value={"none"}>
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small"
              type="button"
              onClick={() => addfield("disputetitle")}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>
          <div>
            <p className="text-sm font-medium mb-2">Cancel Reasons</p>
            <Dropdown className="w-full">
              <DropdownTrigger>
                <Button
                  variant="bordered"
                  className="capitalize w-full justify-start"
                >
                  {selectedCancelReason
                    ? selectedCancelReason.name
                    : "Select Cancel Reason"}
                </Button>
              </DropdownTrigger>

              <DropdownMenu
                aria-label="Single selection example"
                variant="bordered"
                disallowEmptySelection
                selectionMode="single"
                className="max-h-60 overflow-y-auto"
              >
                {cancelReason?.map((item) =>
                  item?.id !== 0 ? (
                    <DropdownItem
                      key={item.id}
                      value={item.id}
                      onClick={() => setSelectedCancelReason(item)}
                    >
                      <div className="flex justify-between w-full">
                        {item.name}
                        <ImBin
                          style={{
                            fontSize: "1rem",
                            color: "gray",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            getDeleteId("cancelreason", item.id, item.name);
                          }}
                        />
                      </div>
                    </DropdownItem>
                  ) : null
                )}
                {cancelReason.length === 0 && (
                  <DropdownItem key="none" value="none">
                    No items
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>

            <button
              className="flex items-center gap-2 text-small mt-2"
              type="button"
              onClick={() => addfield("cancelreason")}
              disabled={isClicked}
            >
              <IoMdAdd />
              <p className="text-sm m-1">Add</p>
            </button>
          </div>
        </div>
      </div>

      <Addfields
        addAssignee={addAssignee}
        property={property}
        fieldID={fieldID}
        closeAssignee={closeAssignee}
        ensureAuth={ensureAuth}
      />
      <AddModal
        isOpen={isOpen}
        onClose={onClose}
        deleteName={deleteName}
        query={query}
        unit={unit}
        deleteItem={deleteItem}
      />
    </div>
  );
};

export default Administration;
